import React, {useContext} from 'react';
import "./QuestionAnswers.scss";
import { ConfigurationContext } from '../../Context/Configuration';

const ResponseSummary = () => {
  const [config, update] = useContext(ConfigurationContext);
  const correctAns = config.questions.filter(a=>a["selectedAnswer"]["isCorrect"]).length;
 
  const responseList = (elem,index) => {
  
      return (
        elem.selectedAnswer["isCorrect"] ?  
                <li key={index}><span>{index+1}</span><span><strong>Correct Answer.</strong> {elem.correctValidation}</span></li> 
                :<li key={index}><span>{index+1}</span><span><strong>Incorrect Answer.</strong> {elem.correctValidation}</span></li> 
      )
  }

  return (
    
    <React.Fragment>
        <div>
            <h1>Response Summary</h1>
            <p>You got <strong>{correctAns} of {config.questions.length}</strong> questions correct.</p>
            <ol>
            {
                
                config.questions.map((elem,index)=>{
                return (
                    responseList(elem,index)
                )
                })
                
            }
        </ol>
         {
             correctAns < 4 ? <p>If you got less than 4 out of 5 answers correct, please take the quiz again to enter.</p> : ""
         }   
        </div>
    </React.Fragment>
   
  );
};

export default ResponseSummary;